import { SxProps } from '@mui/material';

export const newsletterTitleTypographyStylesSx: SxProps = {
	width: 640,
	height: 26,
};
